import { IconProps } from "./IconProps";

export const SupportIcon = (props: IconProps) => {
  return (
    <svg
      width="20"
      height="20"
      className={props.className}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_5_232)">
        <path
          d="M7.57501 7.50002C7.77093 6.94308 8.15763 6.47344 8.66663 6.1743C9.17564 5.87515 9.77409 5.7658 10.356 5.86561C10.9379 5.96543 11.4657 6.26796 11.8459 6.71963C12.2261 7.1713 12.4342 7.74296 12.4333 8.33335C12.4333 10 9.93334 10.8334 9.93334 10.8334M10 14.1667H10.0083M18.3333 10C18.3333 14.6024 14.6024 18.3334 10 18.3334C5.39763 18.3334 1.66667 14.6024 1.66667 10C1.66667 5.39765 5.39763 1.66669 10 1.66669C14.6024 1.66669 18.3333 5.39765 18.3333 10Z"
          stroke="#06123D"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_5_232">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
